var bridgeCallbackQueue = [];

var NEJSBridgeSuccess = false;
var NEJSBridgeWaiting = false;

function setupWebViewJavascriptBridge(callback) {
    if (window.NEJSBridge) {
        if (!NEJSBridgeSuccess) {
            NEJSBridgeSuccess = true;
            console.log('directly get window.NEJSBridge success');
        }
        callback(NEJSBridge);
        return;
    }
    bridgeCallbackQueue.push(callback);
    if (NEJSBridgeWaiting) {
        return;
    }
    NEJSBridgeWaiting = true;
    var NEJSBridgeReady = false;
    document.addEventListener('NEJSBridgeReady', function () {
        console.log('NEJSBridgeReady');
        NEJSBridgeReady = true;
        bridgeCallbackQueue.forEach(function (callback) {
            callback(NEJSBridge);
        });
        bridgeCallbackQueue = [];
    }, false);

    var notifyAppTimes = 0;
    function notifyAppLoaded() {
        notifyAppTimes++;
        console.log('will notifyAppLoaded ' + notifyAppTimes);
        var WVJBIframe = document.createElement('iframe');
        WVJBIframe.style.display = 'none';
        WVJBIframe.src = 'nejb://nejb_loaded';
        document.documentElement.appendChild(WVJBIframe);
        setTimeout(function () {
            document.documentElement.removeChild(WVJBIframe);
        }, 0);
    }
    notifyAppLoaded();
    var notifyAppTimer = setInterval(function () {
        if (notifyAppTimes < 6 && !NEJSBridgeReady) {
            notifyAppLoaded();
        } else {
            clearInterval(notifyAppTimer);
        }
    }, 300);
}

var callHandler$3 = function callHandler(actionName, data, callback) {
    setupWebViewJavascriptBridge(function (bridge) {
        bridge.callHandler(actionName, data, function (resp) {
            if (resp !== undefined) {
                try {
                    resp = JSON.parse(resp);
                } catch (e) {
                    console.log('JSON.parse error', resp, e);
                }
            }
            callback(resp);
        });
    });
};

var registerHandler$1 = function registerHandler(actionName, callback) {
    setupWebViewJavascriptBridge(function (bridge) {
        bridge.registerHandler(actionName, function (resp, responseCallback) {
            if (resp !== undefined) {
                resp = JSON.parse(resp);
            }
            callback(resp, responseCallback);
        });
    });
};
/*
 * LOFTER老版bridge的数据用JSON.parse会报错，使用老版bridge的方式不做处理。
 */
var registerHandler4OldLofter = function registerHandler4OldLofter(actionName, callback) {
    setupWebViewJavascriptBridge(function (bridge) {
        bridge.registerHandler(actionName, function (resp, responseCallback) {
            callback(resp, responseCallback);
        });
    });
};

var stringify = function stringify(query) {
    if (typeof query == 'string') return query;

    var i;
    var result = [];

    for (i in query) {
        if (query.hasOwnProperty(i)) {
            result.push(i + '=' + encodeURIComponent(query[i]));
        }
    }

    return result.join('&');
};

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};

var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

function connectToNative(url, isInApp) {
    if (!isInApp) {
        window.location.href = url;
        return;
    }

    var WVJBIframe = document.createElement('iframe');
    WVJBIframe.style.display = 'none';
    WVJBIframe.src = url;
    document.documentElement.appendChild(WVJBIframe);
    setTimeout(function () {
        document.documentElement.removeChild(WVJBIframe);
    }, 0);
}

var setValueByPath = function setValueByPath(path, value) {
    var array = path.split('.');

    array.reduce(function (acc, currentValue, currentIndex, array) {

        if (currentIndex === array.length - 1) {
            acc[currentValue] = value;
        } else if (acc[currentValue] === undefined || acc[currentValue] === null) {
            acc[currentValue] = {};
        }

        return acc[currentValue];
    }, window);
};

var callHandler$4 = function callHandler(actionName, data, callback, isInApp) {
    var seperator = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : '?';


    if ((typeof callback === 'undefined' ? 'undefined' : _typeof(callback)) === 'object' && callback !== null) {

        if (callback.name !== undefined) {
            setValueByPath(callback.name, function () {
                for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
                    args[_key] = arguments[_key];
                }

                if (typeof callback.handler === 'function') {
                    callback.handler.apply(null, args);
                }
                setValueByPath(callback.name, null);
            });
        }
    }
    var url = actionName + seperator + stringify(data);
    connectToNative(url, isInApp);
};

var patternResult = navigator.userAgent.match(/NEJSBridge\/([\d.]+)\b/);

var isJsbridgeCapable = !!patternResult;

var callHandler$2 = isJsbridgeCapable ? callHandler$3 : callHandler$4;

var libSupport = function libSupport(actionName, versionMap) {
    if (!isJsbridgeCapable || !(actionName in versionMap)) {
        return false;
    }
    var sinceVersoin = versionMap[actionName];
    var currentVersion = parseInt(patternResult[1], 10);

    return sinceVersoin <= currentVersion;
};

var APIAbstract = function () {
    function APIAbstract() {
        classCallCheck(this, APIAbstract);
    }

    createClass(APIAbstract, [{
        key: 'getLegacyProtocolConfig',
        value: function getLegacyProtocolConfig(actionName, data) {
            
        }
    }, {
        key: 'getComputedUrl',
        value: function getComputedUrl(path) {
            if (/^[\w0-9]+:\/\//.test(path)) {
                //'necomics://manhua.163.com/v1', nereader://yuedu.163.com/v1?
                return path;
            }

            return this.schemaName_ + '://' + path;
        }
    }]);
    return APIAbstract;
}();

var APIInstance = void 0;

var schemaCallHandler = function schemaCallHandler(API, actionName, data, callback, seperator) {
    APIInstance = APIInstance || new API();

    var obj = APIInstance.getLegacyProtocolConfig(actionName, data) || {};

    actionName = obj.actionName || actionName;
    data = obj.data || data;
    if (data.seperator !== undefined) {
        seperator = data.seperator; //兼容'neteasereaderuri://entryid=cf3587af574a4056a798878f59fa1b60_4&type=2'
    }

    var oCallback = null;

    if (callback) {
        oCallback = {};
        if (typeof obj.callback === 'string') {
            oCallback.name = obj.callback;
            oCallback.handler = callback;
        } else if (obj.callback !== undefined) {

            if (obj.callback.name === undefined) {
                throw new Error('callback name must be provided');
            }

            oCallback.name = obj.callback.name;
            oCallback.handler = function () {
                for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
                    args[_key] = arguments[_key];
                }

                if (typeof obj.callback.handler === 'function') {
                    var _result = obj.callback.handler.apply(null, args);
                    callback(_result);
                } else {
                    callback.apply(null, result);
                }
            };
        }
    }

    var isInApp = APIInstance.isInApp();

    if (actionName === 'pageRedirect') {
        var path = APIInstance.getComputedUrl(data.path);

        callHandler$2(path, data.query, oCallback, isInApp, seperator);
    } else {
        var _path = APIInstance.getComputedUrl(actionName);

        callHandler$2(_path, data, oCallback, isInApp, seperator);
    }
};

var jsbridgeCallHandler = function jsbridgeCallHandler(API, actionName, data, callback) {
    var seperator = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : '?';

    APIInstance = APIInstance || new API();

    if (actionName === 'pageRedirect') {
        var path = void 0;
        var query = void 0;
        var close = void 0;
        var obj = APIInstance.getLegacyProtocolConfig(actionName, data);

        if (obj) {
            obj = obj.data;
            path = obj.path || data.path;
            query = obj.query || data.query;
            if (obj.seperator !== undefined) {
                seperator = obj.seperator; //兼容'neteasereaderuri://entryid=cf3587af574a4056a798878f59fa1b60_4&type=2'
            }
        } else {
            path = data.path;
            query = data.query;
            close = data.close;
        }

        path = APIInstance.getComputedUrl(path);

        data = { actionUrl: path + seperator + stringify(query) };
        if (close) {
            data.close = close;
        }
    }

    callHandler$2(actionName, data, callback);
};

var doCallHandler = isJsbridgeCapable ? jsbridgeCallHandler : schemaCallHandler;

var callHandler$1 = function callHandler$$1(API, actionName) {
    var data = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var callback = arguments[3];
    var seperator = arguments[4];

    if (typeof data === 'function') {
        callback = data;
        data = {};
    }

    doCallHandler(API, actionName, data, callback, seperator);
};

/*
object-assign
(c) Sindre Sorhus
@license MIT
*/

'use strict';
/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

var objectAssign = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};

var map = {
    playBackgroundMusic: 1,
    njb_cbShareResult: 2,
    njb_setAutoLoginAccountInfo: 3,
    njb_setPageTitle: 4,
    njb_editor_command: 5,
    njb_editor_status: 5,
    njb_editor_getCaret: 5,
    njb_webview_log: 5,
    njb_getDeviceInfo: 6,
    njb_cbCloseWebview: 7,
    njb_updateClient: 7,
    njb_closeCurrentWebview: 7,
    njb_share: 7,
    njb_getAppLog: 7,
    njb_providePullDownRefresh: 7,
    njb_login: 8,
    njb_check_storage_permission: 8, // app 6.9.5
    njb_apply_storage_permission: 8, // app 6.9.5
    njb_reportLogToApp: 9,
    njb_has_applied_unforbid: 10,
    njb_check_notice_permission: 11,
    njb_go_notice_permission: 11,
    njb_getWebViewSessionId: 12,
    njb_live_list_send_gift: 13,
    njb_live_room_user: 13,
    njb_live_room_replay: 14,
    njb_setNavColor: 15,
    njb_provideProgressBar: 15,
    njb_webviewCompleted: 15,
    njb_shareSingleImage: 15,
    njb_noticePageStatus: 16,
    showActionMenu: 17,
    njb_setAppMode: 18,
    njb_recharge: 19,
    njb_changeAvatarBox: 19,
    njb_luckBoyConfig: 20,
    njb_getWebviewCount: 21,
    njb_playAd: 22,
    njb_playAdCallback: 22,
    njb_getABTestConfig: 23,
    njb_publish: 24,
    njb_handleWebCookie: 25,
    njb_unlock_more: 26,
    njb_changeUserSuit: 27,
    njb_getTrySuitStatus: 27,
    njb_trySuit: 27,
    njb_agreement: 28,
    njb_getPostContent: 29,
    njb_buySuccess: 31,
    njb_getWebViewPerformanceInfo: 31,
    njb_cbGetWebViewPerformance: 31,
    njb_cbPresetDataReady: 32,
    njb_cbPresetData: 32,
    njb_getUserConfigs: 32,
    njb_previewImages: 32,
    njb_showSendGift: 32,
    njb_getUserInfo: 32,
    njb_setScreenshotConfig: 32,
    njb_getWindowInfo: 32,
    njb_bindPhoneResult: 33,
    njb_coinPayed: 34,
    njb_fansVipGiftReturned: 34,
    njb_callParagraphComment: 34,
    njb_showParagraphComments: 34,
    njb_cbParagraphCommentPublished: 34,
    njb_cbPictureComment: 34,
    njb_showPictureComments: 34,
    njb_cbPictureCommentPublished: 34,
    njb_stopScroll: 34,
    njb_showImmersiveActionBar: 34,
    njb_log: 34, // ios专属
    // 由于763被带上去了，需要跳过35版本
    njb_cbUnlockReturnGift: 36,
    njb_unlockReturnGift: 36,
    njb_scrollToWebview: 36,
    njb_showPresentGiftTip: 36,
    njb_cbUserConfigsUpdate: 37,
    njb_showToast: 37,
    njb_showGlassmorphismReturnGift: 38,
    njb_cbUpdateReturnGiftChanceCount: 38,
    njb_cbShowUserGuide: 39,
    njb_updateParagraphSweet: 39,
    njb_updatePostActionState: 40,
    njb_cbGlassmorphismChangeCount: 41,
    njb_refreshMessageList: 42,
    njb_webviewAnimationEnd: 43,
    njb_hideCloseButton: 43,
    njb_collectionReturnGiftBuy: 44,
    njb_fetchADOrderFinish: 44
};

var support = function support(actionName) {
    return libSupport(actionName, map);
};

var pageShowActions = {};
if (window.addEventListener) {
    window.addEventListener('pageshow', function (event) {
        if (event.persisted || window.performance && window.performance.navigation.type === 2) {
            for (var pageShowActionsKey in pageShowActions) {
                if (typeof pageShowActions[pageShowActionsKey] === 'function') {
                    pageShowActions[pageShowActionsKey]();
                }
            }
        }
    }, false);
}

var getAppVersion = function getAppVersion() {
    var userAgent = navigator.userAgent;

    if (!userAgent.match(/(iPhone|iPad)/) && !userAgent.match(/Android/)) {
        return false;
    }

    var clientVersionPatternArray = null;
    if (userAgent.match(/(iPhone|iPad)/)) {
        clientVersionPatternArray = userAgent.match(/\bLofter-iPhone ([.0-9]+)\b/i);
    } else if (userAgent.match(/Android/)) {
        clientVersionPatternArray = userAgent.match(/\bLofter-android\/([.0-9]+)\b/i);
    }

    if (!clientVersionPatternArray) {
        return false;
    }

    var clientVersionArray = clientVersionPatternArray[1].split('.');
    return {
        mainVersion: parseInt(clientVersionArray[0], 10),
        subVersion: parseInt(clientVersionArray[1], 10)
    };
};

var getShouldUseNewSchema = function getShouldUseNewSchema() {
    var clientVersionObj = getAppVersion();

    if (!clientVersionObj) return false;

    if (clientVersionObj.mainVersion > 2 || clientVersionObj.mainVersion === 2 && clientVersionObj.subVersion >= 4) {
        return true;
    }

    return false;
};

var getPageRedirectData = function getPageRedirectData(data) {
    var shouldUseNewSchema = getShouldUseNewSchema();

    var action = void 0;
    var a = void 0;
    var newSchemaQuery = {};
    var defaultQuery = {};

    switch (data.path) {

        case 'webview':
            action = 1;
            newSchemaQuery.url = data.query.url;

            if (data.query.auth) {
                newSchemaQuery.auth = data.query.auth;
            }

            if (data.query.title) {
                newSchemaQuery.title = data.query.title;
            }

            defaultQuery.url = data.query.url;

            break;
    }

    var newSchemaPath = 'necomics://manhua.163.com/v1';

    newSchemaQuery.action = action;

    if (shouldUseNewSchema) {
        return {
            path: newSchemaPath,
            query: newSchemaQuery
        };
    }

    if (a) {
        defaultQuery.a = a;
    }

    defaultQuery.actionUrl = newSchemaPath + '?' + stringify(newSchemaQuery);

    return {
        path: 'shareCallback',
        query: defaultQuery
    };
};



/**
 * 老的jsbridge调用
 */
var connectWebViewJavascriptBridge = function connectWebViewJavascriptBridge(callback) {
    if (window.WebViewJavascriptBridge) {
        callback(WebViewJavascriptBridge);
    } else {
        document.addEventListener('WebViewJavascriptBridgeReady', function () {
            callback(WebViewJavascriptBridge);
        }, false);
    }
};

var jbCallHandler4Ios = function jbCallHandler4Ios(_actionName, _data, _callback) {
    connectWebViewJavascriptBridge(function (bridge) {
        bridge.callHandler(_actionName, _data, _callback);
    });
};

var jbRegisterHandler4Ios = function jbRegisterHandler4Ios(_actionName, _callback) {
    connectWebViewJavascriptBridge(function (bridge) {
        bridge.init(function (responseCallback) {
            responseCallback(data);
        });
        bridge.registerHandler(_actionName, _callback);
    });
};

var APILofter = function (_APIAbstract) {
    inherits(APILofter, _APIAbstract);

    function APILofter() {
        classCallCheck(this, APILofter);

        var _this = possibleConstructorReturn(this, (APILofter.__proto__ || Object.getPrototypeOf(APILofter)).call(this));

        _this.schemaName_ = 'neteaselofter';
        return _this;
    }

    createClass(APILofter, [{
        key: 'isInApp',
        value: function isInApp() {
            return navigator.userAgent.indexOf('Lofter') !== -1;
        }
    }, {
        key: 'getLegacyProtocolConfig',
        value: function getLegacyProtocolConfig(actionName, data) {
            switch (actionName) {
                /**
                 * @api {post} saveShareContent 传给客户端保存待分享的内容
                 * @apiName saveShareContent
                 * @apiGroup General
                 * @apiDescription 传给客户端保存待分享的内容
                 * @apiParam {Object}         shareCnt   需要分享的内容
                 * @apiParam (shareCnt)       {Number}   id              分享id，固定为6002即可
                 * @apiParam (shareCnt)       {String}   url             分享链接
                 * @apiParam (shareCnt)       {Object}   content         分享内容数据对象
                 * @apiParam (content)        {String}   weiboImg        微博分享图片
                 * @apiParam (content)        {String}   weiboDesc       微博分享描述
                 * @apiParam (content)        {String}   fImg            微信分享图片
                 * @apiParam (content)        {String}   fDesc           微信分享描述
                 * @apiParam (content)        {String}   fTitle          微信分享标题
                 * @apiParam (content)        {Array}    domains         传空数组即可
                 * @apiParam (content)        {Object}   lofterContent   lofter分享内容
                 * @apiParam (lofterContent)  {String}   lTitle          lofter分享标题
                 * @apiParam (lofterContent)  {String}   lImg            lofter分享图片
                 * @apiParam (lofterContent)  {String}   price           lofter分享价格
                 * @apiParam (lofterContent)  {String}   ext             lofter分享预留字段
                 */

                case 'saveShareContent':
                    return {
                        actionName: 'saveShareContent',
                        data: data ? data : {}
                    };

                /**
                 * @api {get} showMenu 弹出分享组件
                 * @apiName showMenu
                 * @apiGroup General
                 * @apiDescription 弹出分享组件
                 */

                case 'showMenu':

                    return {
                        actionName: 'showMenu'

                        /**
                         * @api {get} hideActionMenu 隐藏当前webview的分享按钮
                         * @apiName hideActionMenu
                         * @apiGroup General
                         * @apiDescription 隐藏当前webview的分享按钮
                         */

                    };case 'hideActionMenu':

                    return {
                        actionName: 'hideActionMenu'

                        /**
                         * @api {post} saveImage 下载图片到系统相册
                         * @apiName saveImage
                         * @apiGroup General
                         * @apiDescription 下载图片到系统相册
                         * @apiParam {Object}  imgdata  "{url:图片链接,data:图片的base64编码}"
                         * @apiParam (imgdata)  url     图片链接;url为空字符串时，启用下一个参数
                         * @apiParam (imgdata)  [data]  图片的base64编码
                         */

                    };case 'saveImage':
                    return {
                        actionName: 'saveImage',
                        data: data ? data : {}
                    };

                /**
                 * @api {get} pickAndUploadPhoto 从本地相册选择图片并上传
                 * @apiName pickAndUploadPhoto
                 * @apiGroup General
                 * @apiDescription 从本地相册选择图片并上传
                 * @apiParam {json} jsondata   字符串，如："{maxsize:1080}" 。 支持传递参数，无参数时，需传递null值;maxsize属性表示图片的最大尺寸
                 */

                case 'pickAndUploadPhoto':
                    return {
                        actionName: 'pickAndUploadPhoto',
                        data: data ? data : null
                    };

                /**
                 * @api {get} isSupportWXPaySDK 询问客户端是否支持微信支付
                 * @apiName isSupportWXPaySDK
                 * @apiGroup General
                 * @apiDescription 询问客户端是否支持微信支付
                 *
                 * @apiSuccess {Boolean} true表示支持，false为不支持
                 */

                case 'isSupportWXPaySDK':

                    return {
                        actionName: 'isSupportWXPaySDK'
                    };

                /**
                 * @api {get} openSystemConfig 弹出弹窗，提示用户去开启系统通知
                 * @apiName openSystemConfig
                 * @apiGroup General
                 * @apiDescription 在用户在乐乎市集产生了新订单，下单并付款完成后弹出
                 */

                case 'openSystemConfig':

                    return {
                        actionName: 'openSystemConfig'
                    };

                /**
                 * @api {post} setLofterBackUrl 设置路径回调
                 * @apiName setLofterBackUrl
                 * @apiGroup General
                 * @apiDescription 设置路径回调
                 * @apiParam {String} url 页面url字符串
                 */

                case 'setLofterBackUrl':
                    var backUrl = data.url ? data.url : 'https://www.lofter.com/market/fe/home/homePage.html';
                    return {
                        actionName: 'setLofterBackUrl',
                        data: backUrl
                    };
                /**
                 * @api {post} njb_setPageTitle 修改页面title
                 * @apiName njb_setPageTitle
                 * @apiGroup General
                 * @apiDescription 修改页面title
                 * @apiParam {String} title 页面title字符串
                 */

                case 'njb_setPageTitle':
                    var title = data ? data : { title: '乐乎市集' };
                    return {
                        actionName: 'njb_setPageTitle',
                        data: title
                    };

                /**
                 * @api {get} refreshMainPageWhenClose 标识关闭当前webview时刷新乐乎市集tab首页
                 * @apiName refreshMainPageWhenClose
                 * @apiGroup General
                 * @apiDescription 前端调这个接口的时候，客户端记一个标志，标识关闭当前webview时刷新乐乎市集tab首页，不做实时刷新了
                 */

                case 'refreshMainPageWhenClose':

                    return {
                        actionName: 'refreshMainPageWhenClose'

                        /**
                         * @api {post} triggerLofterPaySDK 唤起支付
                         * @apiName triggerLofterPaySDK
                         * @apiGroup General
                         * @apiDescription 唤起支付
                         * @apiParam {Number} type 参数type=0为支付宝支付，type=1为微信支付，type=2为IAP（苹果应用内支付）。当type=0时，params为要传递给支付宝的参数(字符串)
                         */

                    };case 'triggerLofterPaySDK':
                    return {
                        actionName: 'triggerLofterPaySDK',
                        data: data ? data : {}
                    };

                /**
                 * @api {post} updateCurrentUrl 通知APP更新页面URL
                 * @apiName updateCurrentUrl
                 * @apiGroup General
                 * @apiDescription 通知APP更新页面URL
                 * @apiParam {String} url 页面url字符串
                 */

                case 'updateCurrentUrl':
                    var currentUrl = data.url ? data.url : 'https://www.lofter.com/market/fe/home/homePage.html';
                    return {
                        actionName: 'updateCurrentUrl',
                        data: currentUrl
                    };

                /**
                 * @api {post} njb_login 唤起登录
                 * @apiName njb_login
                 * @apiGroup v8
                 * @apiDescription 唤起登录
                 * @apiParam {Function} callback 登录后的回调
                 */

                case 'njb_login':
                    return {
                        actionName: 'njb_login',
                        data: { callback: data.callback }
                    };

                /**
                 * @api {get} njb_updateClient 更新客户端或跳转应用商店
                 * @apiName njb_updateClient
                 * @apiGroup v7
                 * @apiDescription 更新客户端或跳转应用商店
                 */

                case 'njb_updateClient':
                    return {
                        actionName: 'njb_updateClient'
                    };

                /**
                 * @api {get} njb_closeCurrentWebview 关闭当前webview
                 * @apiName njb_closeCurrentWebview
                 * @apiGroup v7
                 * @apiDescription 关闭当前webview
                 */

                case 'njb_closeCurrentWebview':
                    return {
                        actionName: 'njb_closeCurrentWebview'
                    };

                /**
                 * @api {post} njb_share 主动分享并设置该次调用的分享参数
                 * @apiName njb_share
                 * @apiGroup v7
                 * @apiDescription 主动分享并设置该次调用的分享参数
                 * @apiParam {Object} shareCnt   需要分享的内容，具体参数同saveShareContent
                 */

                case 'njb_share':
                    return {
                        actionName: 'njb_share',
                        data: data ? data : {}
                    };

                /**
                 * @api {get} njb_getAppLog 获取客户端日志的nos链接
                 * @apiName njb_getAppLog
                 * @apiGroup v7
                 * @apiDescription 获取客户端日志的nos链接
                 */

                case 'njb_getAppLog':
                    return {
                        actionName: 'njb_getAppLog'
                    };

                /**
                 * @api {POST} njb_providePullDownRefresh 提供下拉刷新
                 * @apiName njb_providePullDownRefresh
                 * @apiGroup v7
                 * @apiDescription 提供下拉刷新
                 * @apiParam {Boolean} provide 是否提供下拉刷新
                 */

                case 'njb_providePullDownRefresh':
                    return {
                        actionName: 'njb_providePullDownRefresh',
                        data: data ? data.provide : false
                    };

                /**
                 * @api {post} njb_reportLogToApp 主动通过app上报web日志
                 * @apiName njb_reportLogToApp
                 * @apiGroup v10
                 * @apiDescription 主动通过app上报web日志
                 * @apiParam {Object}         logContent   需要上报的内容
                 * @apiParam (logContent)       {String}   page         页面或者应用标识
                 * @apiParam (logContent)       {String}   timing       时机(比如请求发起、页面加载完成等时候，优先使用performance api中的定义字段)
                 * @apiParam (logContent)       {String}   log         具体信息
                 */

                case 'njb_reportLogToApp':
                    var logContent = '[' + (data.page ? data.page : location.href) + '] ' + (data.timing || '') + ': ' + (data.log || 'no log info.');
                    return {
                        actionName: 'njb_reportLogToApp',
                        data: logContent
                    };

                case 'pageRedirect':

                    return {
                        data: getPageRedirectData(data)
                    };
            }
        }
    }]);
    return APILofter;
}(APIAbstract);

var nejCallHandler = function nejCallHandler(actionName, data, callback) {
    callHandler$1(APILofter, actionName, data, callback);
};

/**
 * NEJSBridge 统一入口封装
 * js调客户端接口
 */
var callHandler$$1 = function callHandler$$1(_actionName, _data, _callback) {
    var ua = navigator.userAgent.toLowerCase();
    var isAOS = ua.indexOf("android") > -1;
    var isIOS = ua.indexOf("iphone") > -1;

    try {
        switch (_actionName) {
            case 'showActionMenu':
                pageShowActions.actionMenu = function () {
                    callHandler$$1('showActionMenu');
                };
                break;
            case 'hideActionMenu':
                pageShowActions.actionMenu = function () {
                    callHandler$$1('hideActionMenu');
                };
                break;
            case 'saveShareContent':
                pageShowActions.saveShareContent = function () {
                    callHandler$$1('saveShareContent', _data);
                };
                break;
        }
    } catch (e) {}

    try {
        _callback = _callback || function () {};
        //新接口一定为NEJSBridge接口，前缀统一为njb_
        if (_actionName.indexOf('njb_') == 0) {
            // 站内callHandler 不会对原始数据做处理，getLegacyProtocolConfig不会生效，可以在这里进行预处理
            switch (_actionName) {
                case 'njb_reportLogToApp':
                    var logContent = '[' + (_data.page ? _data.page : location.href) + '] ' + (_data.timing || '') + ': ' + (_data.log || 'no log info.');
                    _data = {
                        logContent: logContent
                    };
                    break;
            }
            //新接口
            nejCallHandler(_actionName, _data, _callback);
        } else {
            //老接口
            if (isAOS) {
                //如果是saveShareContent，自动将对象类型的data转化为json string
                if (_actionName === 'saveShareContent' && typeof _data !== 'string') {
                    _data = JSON.stringify(_data);
                }
                //android的老接口不接NEJSBridge
                if (_data !== undefined) {
                    // 安卓区分有无参数
                    window.ViewControllerPush[_actionName](_data);
                } else {
                    window.ViewControllerPush[_actionName]();
                }
            } else if (isIOS) {
                //ios新版本（Lofter-iPhone 6.2.0）开始的老接口也接了NEJSBridge
                if (ua.indexOf('nejsbridge') > -1) {
                    //NEJSBridge 方式
                    nejCallHandler(_actionName, _data, _callback);
                } else {
                    //老的ios jsbridge方式
                    jbCallHandler4Ios(_actionName, _data, _callback);
                }
            }
        }
    } catch (e) {}
};

/**
 * NEJSBridge 统一入口封装
 * 注册js接口，供客户端调用
 */
var registerHandler$$1 = function registerHandler$$1(_actionName, _callback) {
    var ua = navigator.userAgent.toLowerCase();
    var isAOS = ua.indexOf("android") > -1;
    var isIOS = ua.indexOf("iphone") > -1;
    try {
        _callback = _callback || function () {};
        //新接口一定为NEJSBridge接口，前缀统一为njb_
        if (_actionName.indexOf('njb_') == 0) {
            //新接口
            registerHandler$1(_actionName, _callback);
        } else {
            //老接口
            if (isAOS) {
                //android的老接口不接NEJSBridge
                switch (_actionName) {
                    case 'cbImgUploaded':
                        if (!window.loft || !window.loft.app || !window.loft.app.g) {
                            window.loft = {
                                app: {
                                    g: {}
                                }
                            };
                        }
                        window.loft.app.g[_actionName] = function (resp) {
                            // 统一参数返回形式,字符串
                            _callback.call(this, JSON.stringify(resp));
                        };
                        break;
                    default:
                        window[_actionName] = _callback;
                }
            } else if (isIOS) {
                //ios新版本（Lofter-iPhone 6.2.0）开始的老接口也接了NEJSBridge
                if (ua.indexOf('nejsbridge') >= 0) {
                    //NEJSBridge 方式，老的接口走独立的注册方式
                    registerHandler4OldLofter(_actionName, _callback);
                } else {
                    //老的ios jsbridge方式
                    jbRegisterHandler4Ios(_actionName, _callback);
                }
            }
        }
    } catch (e) {}
};

export { support, callHandler$$1 as callHandler, registerHandler$$1 as registerHandler, callHandler$4 as schemaCallHandler };
